<template>
  <v-row>

    <v-col cols="12" style="position: relative;">
      
      <v-card>
        <v-btn
          absolute
          dark
          fab
          top
          right
          small
          color="error"
          @click="closeCreate"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>

        <div v-if="loading" class="text-center pa-6">
          <v-progress-circular
            :size="40"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <v-card-text v-else>
          <v-row class="justify-center">
            <v-col cols="12" md="6">
              <div class="title pl-2">Info</div>
              <v-row no-gutters>
                <v-col cols="12" class="pa-1">
                  <v-text-field
                    v-model="name"
                    label="* Name"
                    outlined
                    placeholder=" "
                    :disabled="saving"
                  />
                </v-col>

            
              </v-row>
            </v-col>

          </v-row>
          <v-row>
            <v-col class="text-center">
              <v-btn color="primary" :disabled="!saveable" @click="submit" :loading="saving" v-html="(partnershipId ? 'Update' : 'Create')"></v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AdminPartnershipsEdit',
  data: () => ({
    saving: false,
    loading: true,
    name: null
  }),
  mounted () {
    this.getDataFromApi()
  },
  watch: {
    partnershipId () {
      this.getDataFromApi()
    }
  },
  computed: {
    partnershipId () {
      return this.$route.params.partnership_id
    },
    saveable() {
      if( this.name ) return true
      return false
    }
  },
  methods: {
    submit() {
      if(!this.saveable) return
      this.saving = true

      let data = {
        name: this.name
      }

      let requestType = (this.partnershipId ? 'put' : 'post')
      let requestUrl = (this.partnershipId ? 'partnerships/' + this.partnershipId + '?' : 'partnerships')

      this.$http({
        method: requestType,
        url:    requestUrl,
        data:   data
      })
        .then(() => {
          this.$router.push({name: 'system-admin-partnerships'})
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'There was a problem saving the partnership', 'error')
        })
        .finally(() => {
          this.saving = false
        })
    },

    closeCreate () {
      this.$router.push({name: 'system-admin-partnerships'})
    },

    getDataFromApi() {
      if(!this.partnershipId) {
        this.loading = false
        return
      }
      this.loading = true
      let qParams = []
      this.$http.get('partnerships/' + this.partnershipId + '?' + qParams.join('&'))
        .then(response => {
          this.name                     = response.data.name
          this.loading = false
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'Error loading partnership info', 'error')
        })
    }
  }
}
</script>